// Phase II · Wave C.5a · V12 Achromatic Strict · design tokens.
//
// Every component in the Admin Workbench MUST import these constants
// instead of hand-rolling Tailwind classes. This keeps the surface
// palette-pure and makes the anti-saturation grep test deterministic.
//
// Grid: only neutral-900 (bg), neutral-800 (border), neutral-700
// (ticker fill), neutral-500 (secondary text), neutral-300 (bar fill),
// neutral-100 / neutral-50 (primary text / CTA).
// Depth is signalled via border weight, dash style, opacity · NEVER
// via saturated colour.

export const V12 = {
    // Surfaces
    surface:          "bg-neutral-900 border border-neutral-800",
    surfaceSoft:      "bg-neutral-900/60 border border-neutral-800",
    panel:            "bg-neutral-900 border border-neutral-800 rounded-md",
    hairline:         "border-neutral-800",

    // Text
    textPrimary:      "text-neutral-100",
    textSecondary:    "text-neutral-400",
    textMuted:        "text-neutral-500",
    textCode:         "text-neutral-200 font-mono",

    // Buttons
    btnPrimary:
        "inline-flex items-center justify-center gap-2 rounded-md " +
        "px-3 py-1.5 text-xs font-medium " +
        "bg-neutral-100 text-neutral-900 hover:bg-white " +
        "disabled:bg-neutral-700 disabled:text-neutral-400",
    btnSecondary:
        "inline-flex items-center justify-center gap-2 rounded-md " +
        "px-3 py-1.5 text-xs font-medium " +
        "border border-neutral-700 text-neutral-100 hover:border-neutral-500 " +
        "disabled:border-neutral-800 disabled:text-neutral-500",
    btnGhost:
        "inline-flex items-center justify-center gap-1 rounded-md " +
        "px-2 py-1 text-[11px] " +
        "text-neutral-400 hover:text-neutral-100 " +
        "disabled:text-neutral-700",
    btnDanger:
        "inline-flex items-center justify-center gap-2 rounded-md " +
        "px-3 py-1.5 text-xs font-medium " +
        "border border-neutral-700 text-neutral-200 hover:border-neutral-400",

    // Inputs
    input:
        "w-full rounded-md bg-neutral-900 border border-neutral-800 " +
        "px-3 py-1.5 text-sm text-neutral-100 placeholder-neutral-600 " +
        "focus:outline-none focus:border-neutral-500",
    textarea:
        "w-full rounded-md bg-neutral-900 border border-neutral-800 " +
        "px-3 py-2 text-sm text-neutral-100 placeholder-neutral-600 " +
        "focus:outline-none focus:border-neutral-500 font-mono",

    // Status (semaphore via border weight, NOT colour)
    semaphoreThin:    "border",             // degraded
    semaphoreMedium:  "border-2",           // ok
    semaphoreThick:   "border-4",           // excellent
    semaphoreDashed:  "border border-dashed",   // paused / stale
    semaphoreDotted:  "border border-dotted",   // unknown / guest

    // Chips
    chip:
        "inline-flex items-center gap-1 rounded-sm border border-neutral-700 " +
        "px-1.5 py-0.5 text-[10px] uppercase tracking-wide text-neutral-300",

    // Tables
    thead:            "text-[10px] uppercase tracking-wide text-neutral-500",
    trow:             "border-t border-neutral-800 hover:bg-neutral-900/60",
    td:               "py-2 px-3 text-xs text-neutral-200",
};

export default V12;
